module.exports = __webpack_public_path__ + "img/PT9000.3ded44c0.svg";